import { Component, ViewChild } from '@angular/core';
import { NgbDateParserFormatter, NgbDatepickerModule, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { Subject } from 'rxjs';
import { CommonService } from '../../../Model/Common/common.service';
import { ExpenseService } from '../../../Model/Expense/expense.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { ExpenseItemComponent } from '../../ExpenseItem/expense-item/expense-item.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { DownloadSampleService } from '../../../Model/DownloadSample/download-sample.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { ApprovalMatrixViewComponent } from '../../../approval-matrix-view/approval-matrix-view.component';

@Component({
  selector: 'app-expense-reimbursement',
  standalone: true,
  imports: [DataTablesModule, CommonModule, RouterModule, LoaderComponent, FormsModule, NgbDatepickerModule],
  providers: [{ provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },],
  templateUrl: './expense-reimbursement.component.html',
  styleUrl: './expense-reimbursement.component.scss'
})
export class ExpenseReimbursementComponent {
  isDisabled: boolean = false;
 
  TableDatas = [] as any;
  TableDatasMain = [] as any;
  ReimburseData: any[] = [];
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;

  Filter = {
    ESS_ExpenseReportRequestId: null,
    ESS_TripMasterId: null,
    SelectType: 'AR',
    EmpMasterId: null,
    TravelType: 'Outstation',
    ESS_ExpenseRequestMainId: null,
    ESS_ExpenseRequestDetailsId: null,
    ReimburseType: 'Pending',

    FromDate: '' as any,
    ToDate: '' as any,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpType: 'front'
  }

  dtoptions: DataTables.Settings = {};
  constructor(
    private expense: ExpenseService,
    private session: SessionService,
    private modalService: NgbModal,
    protected common: CommonService,
    private toast: ToastService,
    private dateFormat: CustomDateParserFormatter,
    private download: DownloadSampleService,
    private tooltip: TooltipService,
  ) {
    this.common.getPageRights();
    // this.Filter.EmpMasterId = session.GetUserDetails().UserId;
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ESS_ExpenseRequest_SelectGetFilter();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  ESS_ExpenseRequest_SelectGetFilter() {
    //this.ESS_ExpenseRequest_SelectGetAll();

    // if (this.Filter.TravelType == 'All') {
    //   this.ESS_ExpenseRequest_SelectGetAll();
    // } else {
    //   this.ESS_ExpenseRequest_SelectGet();
    // }
    this.ESS_ExpenseRequest_SelectGet();
  }

  ESS_ExpenseRequest_SelectGet() {
    this.isDisabled = true;
    this.Filter.FromDate = this.Filter.ReimburseType == 'Pending' ? '' : this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.Filter.ReimburseType == 'Pending' ? '' : this.dateFormat.format(this.Filter.ToDateObj);
    this.expense.ESS_ExpenseRequest_SelectGet(this.Filter).subscribe({
      next: (response) => {
        if (response.Table) {
          this.TableDatasMain = response.Table;
        }
        //this.TableDatas = Object.values(this.TableDatasMain.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
        this.FilterReimburseType();
        this.isDisabled = false;
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_ExpenseRequest_SelectGetAll() {
    this.isDisabled = true;
    let responseLocal = [] as any;
    let responseOutstation = [] as any;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    this.expense.ESS_ExpenseRequest_SelectGet({
      FromDate: this.Filter.FromDate,
      ToDate: this.Filter.ToDate,
      ESS_ExpenseReportRequestId: this.Filter.ESS_ExpenseReportRequestId,
      ESS_TripMasterId: this.Filter.SelectType,
      SelectType: this.Filter.SelectType,
      EmpMasterId: this.Filter.EmpMasterId,
      TravelType: 'Local',
      ESS_ExpenseRequestMainId: this.Filter.ESS_ExpenseRequestMainId,
      ESS_ExpenseRequestDetailsId: this.Filter.ESS_ExpenseRequestDetailsId,
    }).subscribe({
      next: (response) => {
        if (response.Table) {
          responseLocal = response.Table;
        }

        this.expense.ESS_ExpenseRequest_SelectGet({
          FromDate: this.Filter.FromDate,
          ToDate: this.Filter.ToDate,
          ESS_ExpenseReportRequestId: this.Filter.ESS_ExpenseReportRequestId,
          ESS_TripMasterId: this.Filter.ESS_TripMasterId,
          SelectType: this.Filter.SelectType,
          EmpMasterId: this.Filter.EmpMasterId,
          TravelType: 'Outstation',
          ESS_ExpenseRequestMainId: this.Filter.ESS_ExpenseRequestMainId,
          ESS_ExpenseRequestDetailsId: this.Filter.ESS_ExpenseRequestDetailsId,
        }).subscribe({
          next: (response) => {
            if (response.Table) {
              responseOutstation = response.Table;
            }

            this.TableDatasMain = [...responseLocal, ...responseOutstation];
            // this.TableDatas = Object.values(this.TableDatasMain.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
            this.FilterReimburseType()
            this.isDisabled = false;
          },
          complete: () => {
          },
          error: (error) => {
            this.isDisabled = false;
          },
        });
      },
      complete: () => {
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  FilterTravelType() {
    this.TableDatas = [];
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
    this.ESS_ExpenseRequest_SelectGetFilter();
  }

  FilterReimburseType() {
    // this.TableDatas = this.TableDatasMain.filter((e: any) => (this.Filter.ReimburseType == 'All' ||
    //   (this.Filter.ReimburseType == 'Pending' && !e.IsReimbursed) || (this.Filter.ReimburseType == 'Reimbursed' && e.IsReimbursed)
    // ));
    this.TableDatas = this.TableDatasMain.filter((e: any) =>
      this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType &&
      (this.Filter.ReimburseType == 'All' ||
        (this.Filter.ReimburseType == 'Pending' && !e.IsReimbursed) ||
        (this.Filter.ReimburseType == 'Reimbursed' && e.IsReimbursed))
    );
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }

  viewItem(index: number) {
    const modalRef = this.modalService.open(ExpenseItemComponent, { size: 'xl', backdrop: 'static', });
    modalRef.componentInstance.TravelType = this.TableDatas[index]['ExpenseType'];
    modalRef.componentInstance.ESS_ExpenseReportRequestId = this.TableDatas[index]['ESS_ExpenseReportRequestId'];
    modalRef.componentInstance.EmpMasterId = this.TableDatas[index]['EmpMasterId'];
    modalRef.componentInstance.IsReimbursed = this.TableDatas[index]['IsReimbursed'];
    modalRef.result.then(
      (result: any) => {
        if (result != undefined && result) {
          this.ESS_ExpenseRequest_SelectGet();
        }
      },
      () => { }
    );
  }

  viewApprovalMatrix(i: number) {
    const modalRef = this.modalService.open(ApprovalMatrixViewComponent, { size: 'md', backdrop: 'static' });
    modalRef.componentInstance.TransactionId = this.TableDatas[i]['ESS_ExpenseReportRequestId'];
    modalRef.componentInstance.EmployeeId = this.TableDatas[i]['EmpMasterId'];
    modalRef.componentInstance.RequestDate = this.TableDatas[i]['RequestDate'];
    modalRef.componentInstance.ApprovalStatus = this.TableDatas[i]['ApprovalStatus'];
    modalRef.componentInstance.ModuleMasterId = 8;
  }

  ESS_ExpenseRequestUpdateAtApproval() {
    if (this.TableDatas.filter((e: any) => e.IsARCheck).length > 0) {
      const checkedSiteIds = this.TableDatas.filter((row: { IsARCheck: any; IsReimbursed: boolean; }) => row.IsARCheck && row.IsReimbursed === false).map((row: { ESS_ExpenseReportRequestId: any; }) => row.ESS_ExpenseReportRequestId);
      const siteIds = checkedSiteIds.join(',');
      console.log('Selected Site IDs:', siteIds);
      //const expenseRequest = this.TableDatas.find((request: { ESS_ExpenseReportRequestId: number; }) => request.ESS_ExpenseReportRequestId === ESS_ExpenseReportRequestId);
      if (siteIds == '') {
        const modalRef = this.modalService.open(AlertWarningComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'This expense request has already been reimbursed.';
        modalRef.result.then(() => { });
        return;
      }
      const modalRef = this.modalService.open(ConfirmationComponent, {
        size: 'md',
        backdrop: 'static',
        centered: true,
        windowClass: 'confirmation-modal'
      });
      modalRef.componentInstance.Message = 'Do you want a reimbursement?';
      modalRef.result.then((result: any) => {
        if (this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) {
          if (result) {
            this.isDisabled = true;
            this.expense.ESS_ExpenseRequestUpdateAtApproval({ SelectType: 'R', ESS_ExpenseReportRequestId: siteIds, ESS_ExpenseRequestDetails: [] }).subscribe({
              next: (response) => {
                if (response.Error_Code == '491') {
                  const modalRef = this.modalService.open(AlertSuccessComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => {
                    this.ESS_ExpenseRequest_SelectGet();
                  });
                  this.isDisabled = false;
                } else {
                  const modalRef = this.modalService.open(AlertWarningComponent, {
                    size: 'md',
                    backdrop: 'static',
                    centered: true,
                    windowClass: 'confirmation-modal'
                  });
                  modalRef.componentInstance.Message = response.Error_Message;
                  modalRef.result.then((result: any) => { });
                  this.isDisabled = false;
                }
              },
              complete: () => { },
              error: (error) => {
                this.isDisabled = false;
              },
            });
          }
        }
        else {
          this.toast.show({ message: this.tooltip.Message.UnauthorizedMessage, type: toastTypeEnum.danger });
        }
      }).catch(() => { });
    }
    else {
      this.toast.show({ message: 'Kindly select atleast one checkbox for Reimbursement', type: toastTypeEnum.warning });
    }
  }

  FilterValidate(form: any) {
    if (form.valid) {
      this.ESS_ExpenseRequest_SelectGetFilter();
    }
    else {
      form.submitted = true;
    }
  }
  ClearData() {
    this.TableDatas = []
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(null);
    });
  }
  ARCheck(event: any, i: number, IsAll = false) {
    if (IsAll) {
      this.TableDatas.map((e: any) => e.IsARCheck = event.target.checked);
    } else {
      this.TableDatas[i].IsARCheck = event.target.checked;
    }
  }
  FilterEmpType(type: string) {
    this.Filter.EmpType = type;
    //this.TableDatas = Object.values(this.TableDatasMain.filter((e: any) => this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType));
    this.FilterReimburseType();
    // this.TableDatas = this.TableDatasMain.filter((e: any) =>
    //   this.common.ToLowerCase(e.EmpType) == this.Filter.EmpType &&
    //   (this.Filter.ReimburseType == 'All' ||
    //     (this.Filter.ReimburseType == 'Pending' && !e.IsReimbursed) ||
    //     (this.Filter.ReimburseType == 'Reimbursed' && e.IsReimbursed))
    // );
    // this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //   dtInstance.destroy();
    //   this.dtTrigger.next(null);
    // });
  }
  exportToExcel() {
    this.isDisabled = true
    //this.Filter.EmpMasterId = this.session.GetUserDetails().UserId;
    this.Filter.FromDate = this.dateFormat.format(this.Filter.FromDateObj);
    this.Filter.ToDate = this.dateFormat.format(this.Filter.ToDateObj);
    const fromDate = new Date(this.Filter.FromDate);
    const toDate = new Date(this.Filter.ToDate);
    if (toDate < fromDate) {
      this.toast.show({ message: 'To Date must be greater than From Date!', type: toastTypeEnum.warning });
      this.isDisabled = false
      return
    }
    const data = {
      SelectType: 'ExpenseReport',
      FromDate: this.Filter.FromDate,
      ToDate: this.Filter.ToDate,
      Approvalstatus: this.Filter.ReimburseType,
      TravelType: this.Filter.TravelType,
      EmpMasterID: null
    }
    this.expense.ESS_ExpenseReport(data).subscribe(
      data => {
        this.ReimburseData = data.Table;
        if (this.ReimburseData.length > 0) {
          this.download.exportToExcel(this.ReimburseData, "OutstationReimburse_data");
          this.isDisabled = false
        }
        else {
          this.toast.show({ message: 'No Data Found!', type: toastTypeEnum.warning });
          this.isDisabled = false
        }
      });
  }

  ExcelDump() {
    if (this.TableDatas.length == 0) {
      this.toast.show({ message: 'No Data Found', type: toastTypeEnum.warning });
    } else {
      this.download.exportToExcelWithProgress(this.TableDatas, 'Outstation Reimbursement')
    }
  }
}
